export const getPriceString = (
  price: number,
  currencySymbol = "£",
  isTypical?: boolean,
  isDiscount = false
): string => {
  const priceDecimal =
    price % 1 === 0
      ? price?.toLocaleString("en-EN")
      : price?.toLocaleString("en-EN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })

  const priceString =
    price >= 0
      ? `${isDiscount ? "-" : ""}${currencySymbol}${
          isTypical ? price : priceDecimal
        }`
      : "Pending..."

  return priceString
}
